// Services
import breedService from "@/app/services/main/breed/breed-service.js"
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { addressMixins } from "@/app/mixins/utils/address-mixins"
import { dateMixins } from '@/app/mixins/utils/date-mixins';

export default {
	name: "PuppyForSalePage",
	components: {},
	mixins: [toastMessageMixins, tableMixins, addressMixins, dateMixins],
	async created() {
		await this.getBreedList()
		const page = this.$store.getters.getCurrentPage;
		this.breederSysId =  this.$route.query.breedSysId;
		if (page > 1) {
			//Multipy page to 10 (default limit) to change the limit depending on the current page number
			const limitNew = page * 10 
			await this.getTableContent(this.page, limitNew)
			this.page = page
			this.shouldScroll = true
		} else if(this.breederSysId) {
			this.columnsFilter['f_breederSysId'] = this.breederSysId;
			this.showClearFilter = true
			this.showBackButton = true
			await this.getTableContent()
		}else {
			this.showBackButton = false
			await this.getTableContent()
		}
	},

	beforeDestroy() {
		// Clear the saved y position and current page in store if the user navigates to another page
		if (this.shouldClearPageScroll) {
			this.clearStore()
		}
	},
	updated() {
		if (this.shouldScroll) {
			// Scroll to the last saved position
			const position = this.$store.getters.getCurrentPosition;
			window.scrollTo(position.x, position.y);
		  }
	},
	watch: {
		'$route'(to, from) {
			if (to.query.breedSysId) {
				this.breederSysId =  this.$route.query.breedSysId;
				this.columnsFilter['f_breederSysId'] = to.query.breedSysId;
				this.selectedState = null
				this.selectedBreed = null
				this.gender = null
				this.selectedPriceOrder = null
				this.puppyNumber = null
				this.showClearFilter = true
				this.showBackButton = true
				this.getTableContent()
			} else {
				this.breederSysId =  null
				this.showClearFilter = false
				this.showBackButton = false
				this.getTableContent()
			}
		}
	  },

	data() {
		return {
			// Breed List
			puppyNumber: '',
			breedList: [],
			breedId: "",
			addedBreedName: "",
			breederSysId: "",
			selectedBreed: "",
			// Size List
			sizeList: [
				{
					value: "Small",
					name: "Small",
				},
				{
					value: "Medium",
					name: "Medium",
				},
			],

			gender: "",
			genderOptions: [
				{
					value: "M",
					name: "Male",
				},
				{
					value: "F",
					name: "Female",
				},
			],
			selectedState: "",
			state: "",
			stateOptions: [
				{
					value: "NSW",
					name: "New South Wales",
				},
				{
					value: "VIC",
					name: "Victoria",
				},
				{
					value: "QLD",
					name: "Queensland",
				},
				{
					value: "WA",
					name: "Western Australia",
				},
				{
					value: "SA",
					name: "South Australia",
				},
				{
					value: "TAS",
					name: "Tasmania",
				},
				{
					value: "NT",
					name: "Northern Territory",
				},
				{
					value: "ACT",
					name: "Australian Capital Territory",
				},
			],
			priceStatus: "",
			priceStatusOptions: [
				{
					value: "Fixed",
					name: "Fixed",
				},
				{
					value: "Negotiable",
					name: "Negotiable",
				},
			],
			selectedPriceOrder: "",
			priceOptions: [
				{
					value: "L",
					name: "Low",
				},
				{
					value: "H",
					name: "High",
				},
			],
			selectedSize: "",
			sizeOptions: [
				{
					value: 2,
					name: "Small",
				},
				{
					value: 3,
					name: "Medium",
				},
				{
					value: 4,
					name: "Large",
				},
			],
			packagePrice: parseInt(process.env.VUE_APP_STORE_CREDIT.replaceAll(",", "")),
			puppySellList: [],
			puppySellTotalCount: 0,
			isShowMore: false,
			// Loading
			isAPILoading: true,
			storeCredit: process.env.VUE_APP_STORE_CREDIT,

			// read more
			puppyDescLimit: 150,
			shouldScroll: true,
			shouldClearPageScroll: true,

			showClearFilter: false,
			showBackButton: false

		}
	},

	computed: {
		displayShowMoreButton() {
			return this.puppySellTotalCount != this.puppySellList.length
		},
	},
	methods: {
		/* 
		* Save the current page and scroll position.
		* Navigate to puppy for sale details and breeder bio
		*/
		navigate(route, id, puppyPack = false){
			this.shouldScroll = true
			this.shouldClearPageScroll = false
			this.$store.commit('setCurrentPage', this.page);
			if (this.breederSysId) {
				this.$store.commit('setPageBreederId', this.breederSysId);
			}
			this.$store.commit('setScrollPosition', { x: window.scrollX, y: window.scrollY });
			const queryParam = puppyPack ? 'breedId' : 'id';
			this.$router.push(`${route}?${queryParam}=${id}`);
		},
		goToDetails(id) {
			this.navigate('/puppy-for-sale/details', id)
		},
		goToBioDetails(id) {
			this.navigate('/breeder-bio', id)
		},
		goToPuppyPacks(id, puppyPack) {
			this.navigate('/puppy-packs', id, puppyPack)
		},
		clearStore() {
			this.$store.commit("clearCurrentPage")
			this.$store.commit("clearCurrentPosition")
		},

		getTableContent(page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			this.getPuppySellList({ page, limit, sortBy, desc: true })
		},
		// Breed List
		getBreedList() {
			breedService.getBreeds().then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.breedList = res.data.data.filter((dt) => dt.id != 0)
					this.$store.commit("setBreedLists", this.breedList)
				} else {
					const { ERROR_GET_BREED_LIST } = this.toastMessages.breed()
					this.showAPIErrorToast(ERROR_GET_BREED_LIST, res)
				}
			})
		},
		createOptionBreed(breed) {
			this.addedBreedName = breed
			return { name: breed, id: `0-${breed}` }
		},
		setSelected(e) {

			if ( this.breederSysId ) {
				this.handleClearFilter();
			}

			if (!e) {
				this.page = 1
				this.breedId = ""
				this.onDropdownFilter("f_breedId", "")
				return
			}

			let selectedId = e

			// If add breed we will check the inputted name if existing in current breed list
			if (!parseInt(e)) {
				const breed = e.split("-")
				const breedName = breed[1]
				const inCurrentBreed = this.breedList.find((item) => {
					return item.name.toLowerCase() === breedName.toLowerCase()
				})
				if (inCurrentBreed) {
					selectedId = inCurrentBreed.id
				} else {
					selectedId = parseInt(breed[0])
				}
				this.breedName = breedName
			}
			this.breederSysId = null 
			this.breedId = selectedId
			this.isShowMore = false
			this.page = 1
			this.onDropdownFilter("f_breedId", selectedId)
		},
		getPuppySellList (queryParams) {
			// search filters
			if (this.columnsFilter) {
				const { f_breedId, f_breedSizeId, f_state, f_gender, f_priceStatus, f_breederId, f_sku, f_breederSysId } =
					this.columnsFilter
				if (!this.breederSysId) {
					if (f_breedId) {
						queryParams["f_breedId"] = f_breedId
					}
	
					if (f_breedSizeId) {
						queryParams["f_breedSizeId"] = f_breedSizeId
					}
	
					if (f_state) {
						queryParams["f_state"] = f_state
					}
	
					if (f_gender) {
						queryParams["f_gender"] = f_gender
					}
	
					if (f_priceStatus) {
						queryParams["f_priceStatus"] = f_priceStatus
					}
	
					if (f_breederId) {
						queryParams["f_breederId"] = f_breederId
					}
	
					if (f_sku) {
						queryParams["f_sku"] = f_sku
					}
				} else {
					if(f_breederSysId) {
						queryParams["f_breederSysId"] = f_breederSysId
					}
				}
				
			}

			this.isAPILoading = true
			puppySellService.getAllApprovedPuppySellList(queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					if (this.isShowMore) {
						this.puppySellList = [...this.puppySellList, ...res.data.data]
						this.isShowMore = false
					} else {
						this.puppySellList = res.data.data
					}
					this.sortByDate()
					this.filterPrice(this.selectedPriceOrder, false)
					this.puppySellTotalCount = res.data.pagination.totalCount
				} else {
					this.showAPIErrorToast("Unable to fetch puppy sell list.", res)
				}
			}).catch(err => {
				this.showGenericErrorToast();
			}).finally(() => {
				this.isAPILoading = false;
			});
			
		},
		showMore() {
			this.isShowMore = true
			this.shouldScroll = false
			this.onPageSelected("next")
		},
		setSelectedFilter(filterBy, e) {
			if ( this.breederSysId ) {
				this.handleClearFilter();
			}
			this.page = 1
			const val = e ? e.value : ""
			this.isShowMore = false
			this.breederSysId = null 
			
			this.onDropdownFilter(filterBy, val)
			this.clearStore()
		},
		calculateRepayments(puppyPrice, storeCredit) {
			const price = parseFloat(puppyPrice)
			const storeCreds = parseFloat(storeCredit)
			const total = price + storeCreds
			return parseInt(total / 24)
		},
		hasProductImage(productImage) {
			let image = require("@/assets/images/_shared/dog-purchase.png")

			if (productImage) {
				image = productImage
			}

			return image
		},
		filterPrice(e, isDeleteBreederId) {
			if ( this.breederSysId && isDeleteBreederId) {
				this.handleClearFilter();
			}
			if (!e) {
				this.sortByDate()
				return
			}
			
			if (e.name === "Low") {
				this.puppySellList = this.puppySellList.sort(
					(a, b) => parseFloat(a.totalPrice) - parseFloat(b.totalPrice)
				)
			} else {
				this.puppySellList = this.puppySellList.sort(
					(a, b) => parseFloat(b.totalPrice) - parseFloat(a.totalPrice)
				)
			}
		},

		sortByDate() {
			this.puppySellList.sort(function (a, b) {
				// Turn your strings into dates, and then subtract them
				// to get a value that is either negative, positive, or zero.
				return new Date(b.createdAt) - new Date(a.createdAt)
			})
		},

		readMoreAndModal(event, puppyImageUrl, puppyDesc, puppyHeadline) {
			event.stopPropagation(); // this stops the container(card) which is clickable from redirecting the user to the puppy details page

			const puppyPrimaryImage = puppyImageUrl ? puppyImageUrl : require('@/assets/images/_shared/dog-smile.svg');

			this.$swal({
				imageUrl: puppyPrimaryImage,
				imageHeight: "200px",
				html: `<p style="font-weight: bold !important;">${puppyHeadline || ""}</p><p>${puppyDesc || ""}</p>`,
				confirmButtonText: "Close",
				showConfirmButton: true,
				showCancelButton: false,
			})

		},
		onPastePuppyNumber(event) {
			
			if (this.breederSysId ) {
				this.handleClearFilter();
			}

			const pastedText = event.clipboardData.getData('text/plain');

			// Replace any non-numeric characters
			const cleanedValue = pastedText.replace(/[^0-9]/g, '');
			event.target.value = cleanedValue;
		
			if(!isNaN(cleanedValue)){
				event.preventDefault(); // prevents the oninput from being called, making the value redundant
			}


			this.puppyNumber = cleanedValue

			this.breederSysId = null

			this.onColumnFilter('f_sku', event);

			
		},

		onInputChangePuppyNumber(event) {
			if (this.breederSysId ) {
				this.handleClearFilter();
			}
			const inputValue = event.target.value;

			// Replace any non-numeric characters
			const cleanedValue = inputValue.replace(/[^0-9]/g, '');
			event.target.value = cleanedValue;

			if(isNaN(inputValue)){
				event.preventDefault();
				return;
			}
			this.puppyNumber = cleanedValue
			this.breederSysId = null

			this.onColumnFilter('f_sku', event);
		},
		
		handleClearFilter() {
			this.columnsFilter['f_breederSysId'] = ''
			this.$router.push(this.$route.path).catch(err => {});
		},
		handleRefreshContent() {
			// Reset filters in the columnsFilter object
			this.columnsFilter = {
				f_breederSysId: '',
				f_breedId: '',
				f_breedSizeId: '',
				f_state: '',
				f_gender: '',
				f_priceStatus: '',
				f_breederId: '',
				f_sku: '',
			};
			
			const isReload = this.breederSysId ? true : false
			// Reset other relevant properties
			this.breederSysId = null;
			this.selectedBreed = null;
			this.gender = null;
			this.selectedState = null;
			this.puppyNumber = '';
			this.selectedPriceOrder = null;
			this.page = 1; // Reset to the first page
			this.isShowMore = false; // Reset 'show more' state
			this.showClearFilter = false; // Hide clear filter button

			if (isReload)
				this.$router.push(this.$route.path).catch(err => {});
			else  this.getTableContent()
		}
	},

	
}
